/* eslint-disable react-hooks/rules-of-hooks */
import moment from "moment";
import frLocale from "moment/locale/fr";
import axios from "axios";

export const changeDateFormatFrench =(date)=>{
    moment.locale('fr', [frLocale])
    
    return moment(date).format('LL');
}

export const changeDateFormatFrenchDynamic =(date,dateformat='LL')=>{
    moment.locale('fr', [frLocale])
    
    return moment(date).format(dateformat);
}
export const convertNumberFrench =(get_number)=>{       
    const number = Number(get_number);
    return number.toLocaleString("fr-FR");
}
export const isValidEmail =(email)=>{ 
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}

export const isAlphabetic =(inputVal)=>{ 
    const regex = /^[A-Za-z\s]+$/;
    return (typeof inputVal === "string" && inputVal.length>0 && regex.test(inputVal));
}

export const isNumericValue =(value)=>{ 
    return value.length>0 && /^\d*$/.test(value);
}
export const isValidPhoneNumber = (phone) => {
    if (!phone) return false;
    // Remove all spaces and check if it matches the pattern
    const cleanedPhone = phone.replace(/\s/g, '');
    return /^0[1-9]\d{8}$/.test(cleanedPhone);
};
export function extractFirstNonEmptyParagraph(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const ps = doc.querySelectorAll("p");
  for (const p of ps) {
    const txt = p.textContent?.trim();
    if (txt) return txt;
  }
  return null;
}
export const getDetailsBydepartement =(value)=>{ 
    const departments = [
        { id: 1, department_name: "Ain", department_num: 1 },
        { id: 2, department_name: "Aisne", department_num: 2 },
        { id: 3, department_name: "Allier", department_num: 3 },
        { id: 4, department_name: "Alpes-de-Haute-Provence", department_num: 4 },
        { id: 5, department_name: "Hautes-Alpes", department_num: 5 },
        { id: 6, department_name: "Alpes-Maritimes", department_num: 6 },
        { id: 7, department_name: "Ardèche", department_num: 7 },
        { id: 8, department_name: "Ardennes", department_num: 8 },
        { id: 9, department_name: "Ariège", department_num: 9 },
        { id: 10, department_name: "Aube", department_num: 10 },
        { id: 11, department_name: "Aude", department_num: 11 },
        { id: 12, department_name: "Aveyron", department_num: 12 },
        { id: 13, department_name: "Bouches-du-Rhône", department_num: 13 },
        { id: 14, department_name: "Calvados", department_num: 14 },
        { id: 15, department_name: "Cantal", department_num: 15 },
        { id: 16, department_name: "Charente", department_num: 16 },
        { id: 17, department_name: "Charente-Maritime", department_num: 17 },
        { id: 18, department_name: "Cher", department_num: 18 },
        { id: 19, department_name: "Corrèze", department_num: 19 },
        { id: 20, department_name: "Corse-du-sud", department_num: "2A" },
        { id: 21, department_name: "Haute-corse", department_num: "2B" },
        { id: 22, department_name: "Côte-d'Or", department_num: 21 },
        { id: 23, department_name: "Côtes-d'armor", department_num: 22 },
        { id: 24, department_name: "Creuse", department_num: 23 },
        { id: 25, department_name: "Dordogne", department_num: 24 },
        { id: 26, department_name: "Doubs", department_num: 25 },
        { id: 27, department_name: "Drôme", department_num: 26 },
        { id: 28, department_name: "Eure", department_num: 27 },
        { id: 29, department_name: "Eure-et-Loir", department_num: 28 },
        { id: 30, department_name: "Finistère", department_num: 29 },
        { id: 31, department_name: "Gard", department_num: 30 },
        { id: 32, department_name: "Haute-Garonne", department_num: 31 },
        { id: 33, department_name: "Gers", department_num: 32 },
        { id: 34, department_name: "Gironde", department_num: 33 },
        { id: 35, department_name: "Hérault", department_num: 34 },
        { id: 36, department_name: "Ille-et-Vilaine", department_num: 35 },
        { id: 37, department_name: "Indre", department_num: 36 },
        { id: 38, department_name: "Indre-et-Loire", department_num: 37 },
        { id: 39, department_name: "Isère", department_num: 38 },
        { id: 40, department_name: "Jura", department_num: 39 },
        { id: 41, department_name: "Landes", department_num: 40 },
        { id: 42, department_name: "Loir-et-Cher", department_num: 41 },
        { id: 43, department_name: "Loire", department_num: 42 },
        { id: 44, department_name: "Haute-Loire", department_num: 43 },
        { id: 45, department_name: "Loire-Atlantique", department_num: 44 },
        { id: 46, department_name: "Loiret", department_num: 45 },
        { id: 47, department_name: "Lot", department_num: 46 },
        { id: 48, department_name: "Lot-et-Garonne", department_num: 47 },
        { id: 49, department_name: "Lozère", department_num: 48 },
        { id: 50, department_name: "Maine-et-Loire", department_num: 49 },
        { id: 51, department_name: "Manche", department_num: 50 },
        { id: 52, department_name: "Marne", department_num: 51 },
        { id: 53, department_name: "Haute-Marne", department_num: 52 },
        { id: 54, department_name: "Mayenne", department_num: 53 },
        { id: 55, department_name: "Meurthe-et-Moselle", department_num: 54 },
        { id: 56, department_name: "Meuse", department_num: 55 },
        { id: 57, department_name: "Morbihan", department_num: 56 },
        { id: 58, department_name: "Moselle", department_num: 57 },
        { id: 59, department_name: "Nièvre", department_num: 58 },
        { id: 60, department_name: "Nord", department_num: 59 },
        { id: 61, department_name: "Oise", department_num: 60 },
        { id: 62, department_name: "Orne", department_num: 61 },
        { id: 63, department_name: "Pas-de-Calais", department_num: 62 },
        { id: 64, department_name: "Puy-de-Dôme", department_num: 63 },
        { id: 65, department_name: "Pyrénées-Atlantiques", department_num: 64 },
        { id: 66, department_name: "Hautes-Pyrénées", department_num: 65 },
        { id: 67, department_name: "Pyrénées-Orientales", department_num: 66 },
        { id: 68, department_name: "Bas-Rhin", department_num: 67 },
        { id: 69, department_name: "Haut-Rhin", department_num: 68 },
        { id: 70, department_name: "Rhône", department_num: 69 },
        { id: 71, department_name: "Haute-Saône", department_num: 70 },
        { id: 72, department_name: "Saône-et-Loire", department_num: 71 },
        { id: 73, department_name: "Sarthe", department_num: 72 },
        { id: 74, department_name: "Savoie", department_num: 73 },
        { id: 75, department_name: "Haute-Savoie", department_num: 74 },
        { id: 76, department_name: "Paris", department_num: 75 },
        { id: 77, department_name: "Seine-Maritime", department_num: 76 },
        { id: 78, department_name: "Seine-et-Marne", department_num: 77 },
        { id: 79, department_name: "Yvelines", department_num: 78 },
        { id: 80, department_name: "Deux-Sèvres", department_num: 79 },
        { id: 81, department_name: "Somme", department_num: 80 },
        { id: 82, department_name: "Tarn", department_num: 81 },
        { id: 83, department_name: "Tarn-et-Garonne", department_num: 82 },
        { id: 84, department_name: "Var", department_num: 83 },
        { id: 85, department_name: "Vaucluse", department_num: 84 },
        { id: 86, department_name: "Vendée", department_num: 85 },
        { id: 87, department_name: "Vienne", department_num: 86 },
        { id: 88, department_name: "Haute-Vienne", department_num: 87 },
        { id: 89, department_name: "Vosges", department_num: 88 },
        { id: 90, department_name: "Yonne", department_num: 89 },
        { id: 91, department_name: "Territoire de Belfort", department_num: 90 },
        { id: 92, department_name: "Essonne", department_num: 91 },
        { id: 93, department_name: "Hauts-de-Seine", department_num: 92 },
        { id: 94, department_name: "Seine-Saint-Denis", department_num: 93 },
        { id: 95, department_name: "Val-de-Marne", department_num: 94 },
        { id: 96, department_name: "Val-d'oise", department_num: 95 },
        { id: 97, department_name: "Guadeloupe", department_num: 971 },
        { id: 98, department_name: "Martinique", department_num: 972 },
        { id: 99, department_name: "Guyane", department_num: 973 },
        { id: 100, department_name: "Réunion", department_num: 974 },
        { id: 101, department_name: "Mayotte", department_num: 976 },
        { id: 102, department_name: "Saint-Barthélémy", department_num: 977 },
        { id: 103, department_name: "Saint-Martin", department_num: 978 }
      ];
      
      // Find department_num where id is 75
      // Convert value to number for proper comparison, since IDs are numbers
      const numericValue = parseInt(value, 10);
      //console.log('value type:', typeof value, 'value:', value);
     // console.log('numericValue:', numericValue);
      const department = departments.find(dept => dept.id === numericValue);
      //console.log('department:', department);
      
      return department?.department_num;
}


export const getDetailsBySiren =async(sirenNo)=>{
    try {       
        const fetchResponse = await axios.get(`${process.env.REACT_APP_API_URL}api/announce/sirenDetails/${sirenNo}`);       
        if(fetchResponse)
        {
            return fetchResponse.data.data;
        }
        else
        {
            return {
                siren:"", denomination:"", forme_juridique:"",capital_social:"",adresse_rcs:"", code_postal:"",ville:"", area:"",cityArr:[],ville_id:"",
            };
        }
    } catch (e) {
        return {
            siren:"", denomination:"", forme_juridique:"",capital_social:"",adresse_rcs:"", code_postal:"",ville:"", area:"",cityArr:[],ville_id:""
        };
    } 
    
}
export const decodedStringValue =(value)=>{ 
    let encodedString = value;
    let div = document.createElement('div');
    div.innerHTML = encodedString;
    let decodedString = div.innerText || div.textContent;
    return decodedString;
}

export const getMonthsStartingWithCurrent = () => {
    const monthNames = [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];
  
    const currentMonthIndex = new Date().getMonth();
    const monthsStartingWithCurrent = [
      ...monthNames.slice(currentMonthIndex),
      ...monthNames.slice(0, currentMonthIndex)
    ];
  
    return monthsStartingWithCurrent;
  };
  export function getFormJuridique(code) {
    const forms = {
      "0000": "Organisme de placement collectif en valeurs mobilières sans personnalité morale",
      "1000": "Entrepreneur individuel",
      "2110": "Indivision entre personnes physiques",
      "2120": "Indivision avec personne morale",
      "2210": "Société créée de fait entre personnes physiques",
      "2220": "Société créée de fait avec personne morale",
      "2310": "Société en participation entre personnes physiques",
      "2320": "Société en participation avec personne morale",
      "2385": "Société en participation de professions libérales",
      "2400": "Fiducie",
      "2700": "Paroisse hors zone concordataire",
      "2900": "Autre groupement de droit privé non doté de la personnalité morale",
      "3110": "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS",
      "3120": "Société commerciale étrangère immatriculée au RCS",
      "3205": "Organisation internationale",
      "3210": "État, collectivité ou établissement public étranger",
      "3220": "Société étrangère non immatriculée au RCS",
      "3290": "Autre personne morale de droit étranger",
      "4110": "Établissement public national à caractère industriel ou commercial doté d'un comptable public",
      "4120": "Établissement public national à caractère industriel ou commercial non doté d'un comptable public",
      "4130": "Exploitant public",
      "4140": "Établissement public local à caractère industriel ou commercial",
      "4150": "Régie d'une collectivité locale à caractère industriel ou commercial",
      "4160": "Institution Banque de France",
      "5191": "Société de caution mutuelle",
      "5192": "Société coopérative de banque populaire",
      "5193": "Caisse de crédit maritime mutuel",
      "5194": "Caisse (fédérale) de crédit mutuel",
      "5195": "Association coopérative inscrite (droit local Alsace Moselle)",
      "5196": "Caisse d'épargne et de prévoyance à forme coopérative",
      "5202": "Société en nom collectif",
      "5203": "Société en nom collectif coopérative",
      "5306": "Société en commandite simple",
      "5307": "Société en commandite simple coopérative",
      "5308": "Société en commandite par actions",
      "5309": "Société en commandite par actions coopérative",
      "5310": "Société en libre partenariat (SLP)",
      "5370": "Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)",
      "5385": "Société d'exercice libéral en commandite par actions",
      "5410": "SARL nationale",
      "5415": "SARL d'économie mixte",
      "5422": "SARL immobilière pour le commerce et l'industrie (SICOMI)",
      "5426": "SARL immobilière de gestion",
      "5430": "SARL d'aménagement foncier et d'équipement rural (SAFER)",
      "5431": "SARL mixte d'intérêt agricole (SMIA)",
      "5432": "SARL d'intérêt collectif agricole (SICA)",
      "5442": "SARL d'attribution",
      "5443": "SARL coopérative de construction",
      "5451": "SARL coopérative de consommation",
      "5453": "SARL coopérative artisanale",
      "5454": "SARL coopérative d'intérêt maritime",
      "5455": "SARL coopérative de transport",
      "5458": "SARL coopérative ouvrière de production (SCOP)",
      "5459": "SARL union de sociétés coopératives",
      "5460": "Autre SARL coopérative",
      "5470": "Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)",
      "5485": "Société d'exercice libéral à responsabilité limitée",
      "5498": "SARL unipersonnelle",
      "5499": "Société à responsabilité limitée (sans autre indication)",
      "5505": "SA à participation ouvrière à conseil d'administration",
      "5510": "SA nationale à conseil d'administration",
      "5515": "SA d'économie mixte à conseil d'administration",
      "5520": "Fonds à forme sociétale à conseil d'administration",
      "5522": "SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration",
      "5525": "SA immobilière d'investissement à conseil d'administration",
      "5530": "SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration",
      "5531": "Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration",
      "5532": "SA d'intérêt collectif agricole (SICA) à conseil d'administration",
      "5542": "SA d'attribution à conseil d'administration",
      "5543": "SA coopérative de construction à conseil d'administration",
      "5546": "SA de HLM à conseil d'administration",
      "5547": "SA coopérative de production de HLM à conseil d'administration",
      "5548": "SA de crédit immobilier à conseil d'administration",
      "5551": "SA coopérative de consommation à conseil d'administration",
      "5552": "SA coopérative de commerçants-détaillants à conseil d'administration",
      "5553": "SA coopérative artisanale à conseil d'administration",
      "5554": "SA coopérative (d'intérêt) maritime à conseil d'administration",
      "5555": "SA coopérative de transport à conseil d'administration",
      "5558": "SA coopérative ouvrière de production (SCOP) à conseil d'administration",
      "5559": "SA union de sociétés coopératives à conseil d'administration",
      "5560": "Autre SA coopérative à conseil d'administration",
      "5570": "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)",
      "5585": "Société d'exercice libéral à forme anonyme à conseil d'administration",
      "5599": "SA à conseil d'administration (s.a.i.)",
      "5605": "SA à participation ouvrière à directoire",
      "5610": "SA nationale à directoire",
      "5615": "SA d'économie mixte à directoire",
      "5620": "Fonds à forme sociétale à directoire",
      "5622": "SA immobilière pour le commerce et l'industrie (SICOMI) à directoire",
      "5625": "SA immobilière d'investissement à directoire",
      "5630": "Safer anonyme à directoire",
      "5631": "SA mixte d'intérêt agricole (SMIA)",
      "5632": "SA d'intérêt collectif agricole (SICA)",
      "5642": "SA d'attribution à directoire",
      "5643": "SA coopérative de construction à directoire",
      "5646": "SA de HLM à directoire",
      "5647": "Société coopérative de production de HLM anonyme à directoire",
      "5648": "SA de crédit immobilier à directoire",
      "5651": "SA coopérative de consommation à directoire",
      "5652": "SA coopérative de commerçants-détaillants à directoire",
      "5653": "SA coopérative artisanale à directoire",
      "5654": "SA coopérative d'intérêt maritime à directoire",
      "5655": "SA coopérative de transport à directoire",
      "5658": "SA coopérative ouvrière de production (SCOP) à directoire",
      "5659": "SA union de sociétés coopératives à directoire",
      "5660": "Autre SA coopérative à directoire",
      "5670": "Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)",
      "5685": "Société d'exercice libéral à forme anonyme à directoire",
      "5699": "SA à directoire (s.a.i.)",
      "5710": "SAS, société par actions simplifiée",
      "5720": "Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle",
      "5770": "Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)",
      "5785": "Société d'exercice libéral par action simplifiée",
      "5800": "Société européenne",
      "6100": "Caisse d'Épargne et de Prévoyance",
      "6210": "Groupement européen d'intérêt économique (GEIE)",
      "6220": "Groupement d'intérêt économique (GIE)",
      "6316": "Coopérative d'utilisation de matériel agricole en commun (CUMA)",
      "6317": "Société coopérative agricole",
      "6318": "Union de sociétés coopératives agricoles",
      "6411": "Société d'assurance à forme mutuelle",
      "6511": "Sociétés Interprofessionnelles de Soins Ambulatoires",
      "6521": "Société civile de placement collectif immobilier (SCPI)",
      "6532": "Société civile d'intérêt collectif agricole (SICA)",
      "6533": "Groupement agricole d'exploitation en commun (GAEC)",
      "6534": "Groupement foncier agricole",
      "6535": "Groupement agricole foncier",
      "6536": "Groupement forestier",
      "6537": "Groupement pastoral",
      "6538": "Groupement foncier et rural",
      "6539": "Société civile foncière",
      "6540": "Société civile immobilière",
      "6541": "Société civile immobilière de construction-vente",
      "6542": "Société civile d'attribution",
      "6543": "Société civile coopérative de construction",
      "6544": "Société civile immobilière d'accession progressive à la propriété",
      "6551": "Société civile coopérative de consommation",
      "6554": "Société civile coopérative d'intérêt maritime",
      "6558": "Société civile coopérative entre médecins",
      "6560": "Autre société civile coopérative",
      "6561": "SCP d'avocats",
      "6562": "SCP d'avocats aux conseils",
      "6563": "SCP d'avoués d'appel",
      "6564": "SCP d'huissiers",
      "6565": "SCP de notaires",
      "6566": "SCP de commissaires-priseurs",
      "6567": "SCP de greffiers de tribunal de commerce",
      "6568": "SCP de conseils juridiques",
      "6569": "SCP de commissaires aux comptes",
      "6571": "SCP de médecins",
      "6572": "SCP de dentistes",
      "6573": "SCP d'infirmiers",
      "6574": "SCP de masseurs-kinésithérapeutes",
      "6575": "SCP de directeurs de laboratoire d'analyse médicale",
      "6576": "SCP de vétérinaires",
      "6577": "SCP de géomètres experts",
      "6578": "SCP d'architectes",
      "6585": "Autre société civile professionnelle",
      "6588": "Société civile laitière",
      "6589": "Société civile de moyens",
      "6595": "Caisse locale de crédit mutuel",
      "6596": "Caisse de crédit agricole mutuel",
      "6597": "Société civile d'exploitation agricole",
      "6598": "Exploitation agricole à responsabilité limitée",
      "6599": "Autre société civile",
      "6901": "Autre personne de droit privé inscrite au registre du commerce et des sociétés",
      "9900": "Autre personne morale de droit privé"
    };
  
    // Convert number to string if needed
    const codeStr = code.toString();
    console.log('codeStr',codeStr);
    return forms[codeStr] || 'Forme juridique inconnue';
  }
